<template>
  <div class="mobile-streaming" id="mobile-streaming">
    <header class="streaming-header">
      <!-- <MobileNav /> -->

      <div class="streaming-header__title">
        <img
          src="@/assets/image/index/mobile_header_cd.webp"
          alt="Decorative lightning bolt image"
          width="190"
          height="186"
          class="streaming-header__dynamic streaming-header__dynamic-cd"
        />
        <img
          src="@/assets/image/index/mobile_header_lightning.webp"
          alt="Decorative lightning bolt image"
          width="96"
          height="96"
          decoding="async"
          class="streaming-header__dynamic streaming-header__dynamic-lightning"
        />
        <img
          class="streaming-header__title-img"
          src="@/assets/image/streaming/mobile_title.webp"
          alt="Streaming page title graphic"
          width="288"
          height="30"
          decoding="async"
          loading="lazy"
        />
      </div>

      <div class="mobile-marquee mobile-marquee--banner">
        <div class="mobile-marquee-inner">
          <div class="mobile-marquee-track">
            <div
              v-for="dup in 2"
              :key="'mobile-marquee-banner-' + dup"
              class="mobile-marquee-group"
              :aria-hidden="dup === 2 ? 'true' : undefined"
            >
              <img
                v-for="item in 10"
                :key="`mobile-banner-${dup}-${item}`"
                class="mobile-marquee-title"
                src="@/assets/image/index/about_footer_title.webp"
                width="200"
                height="20"
                alt="Scrolling footer title strip (decorative)"
                aria-hidden="true"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </div>
    </header>

    <section
      class="streaming-body mobile-business-fade-up"
      :aria-label="mobileStreamingCopy.liveTicket.ariaLabel"
    >
      <div class="streaming-body__content">
        <div class="streaming-body__content-top">
          <div class="streaming-body__content-title">
            <div class="streaming-body__content-title--text">
              {{ mobileStreamingCopy.liveTicket.title }}
            </div>
            <div class="streaming-body__content-title--price">
              {{ mobileStreamingCopy.liveTicket.price }}
            </div>
          </div>
          <div class="streaming-body__content-date">
            <div class="streaming-body__content-date--label">
              {{ mobileStreamingCopy.liveTicket.periodBadge }}
            </div>
            <div class="streaming-body__content-date--value">
              {{ mobileStreamingCopy.liveTicket.periodRange }}
            </div>
          </div>
        </div>

        <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="361"
            height="19"
            viewBox="0 0 361 19"
            fill="none"
          >
            <path
              d="M0.5 11.0118H0V12.0118H0.5V11.5118V11.0118ZM327.904 11.5118L328.382 11.363C328.317 11.1541 328.123 11.0118 327.904 11.0118V11.5118ZM330.082 18.5L329.605 18.6488C329.664 18.8397 329.832 18.9768 330.031 18.9974C330.23 19.0179 330.422 18.9179 330.519 18.7432L330.082 18.5ZM340.101 0.5L340.595 0.421857C340.562 0.211223 340.398 0.0449096 340.188 0.00767881C339.978 -0.0295519 339.768 0.0704949 339.664 0.256831L340.101 0.5ZM341.843 11.5118L341.35 11.5899C341.388 11.8329 341.597 12.0118 341.843 12.0118V11.5118ZM360.5 12.0118C360.776 12.0118 361 11.7879 361 11.5118C361 11.2356 360.776 11.0118 360.5 11.0118V11.5118V12.0118ZM0.5 11.5118V12.0118H327.904V11.5118V11.0118H0.5V11.5118ZM327.904 11.5118L327.427 11.6605L329.605 18.6488L330.082 18.5L330.56 18.3512L328.382 11.363L327.904 11.5118ZM330.082 18.5L330.519 18.7432L340.538 0.743169L340.101 0.5L339.664 0.256831L329.645 18.2568L330.082 18.5ZM340.101 0.5L339.607 0.578143L341.35 11.5899L341.843 11.5118L342.337 11.4336L340.595 0.421857L340.101 0.5ZM341.843 11.5118V12.0118H360.5V11.5118V11.0118H341.843V11.5118Z"
              fill="#FFF380"
            />
          </svg>
        </div>

        <ul class="streaming-body__content-notes">
          <li
            class="streaming-body__content-notes-heading"
            v-html="mobileStreamingCopy.noticeHeadingHtml"
          />
          <li v-for="(line, idx) in liveNoticeLines" :key="'live-n-' + idx">
            ・{{ line }}
          </li>
        </ul>
      </div>
    </section>

    <section
      class="streaming-body mobile-business-fade-up mobile-business-fade-up--delay-1"
      :aria-label="mobileStreamingCopy.archive.ariaLabel"
    >
      <div class="streaming-body__content">
        <div class="streaming-body__content-top">
          <div class="streaming-body__content-title">
            <div class="streaming-body__content-title--text">
              {{ mobileStreamingCopy.archive.title }}
            </div>
          </div>
          <div class="streaming-body__content-date">
            <div class="streaming-body__content-date--label">
              {{ mobileStreamingCopy.archive.periodBadge }}
            </div>
            <div class="streaming-body__content-date--value">
              {{ mobileStreamingCopy.archive.mobilePeriodRange }}
            </div>
          </div>
        </div>

        <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="361"
            height="19"
            viewBox="0 0 361 19"
            fill="none"
          >
            <path
              d="M0.5 11.0118H0V12.0118H0.5V11.5118V11.0118ZM327.904 11.5118L328.382 11.363C328.317 11.1541 328.123 11.0118 327.904 11.0118V11.5118ZM330.082 18.5L329.605 18.6488C329.664 18.8397 329.832 18.9768 330.031 18.9974C330.23 19.0179 330.422 18.9179 330.519 18.7432L330.082 18.5ZM340.101 0.5L340.595 0.421857C340.562 0.211223 340.398 0.0449096 340.188 0.00767881C339.978 -0.0295519 339.768 0.0704949 339.664 0.256831L340.101 0.5ZM341.843 11.5118L341.35 11.5899C341.388 11.8329 341.597 12.0118 341.843 12.0118V11.5118ZM360.5 12.0118C360.776 12.0118 361 11.7879 361 11.5118C361 11.2356 360.776 11.0118 360.5 11.0118V11.5118V12.0118ZM0.5 11.5118V12.0118H327.904V11.5118V11.0118H0.5V11.5118ZM327.904 11.5118L327.427 11.6605L329.605 18.6488L330.082 18.5L330.56 18.3512L328.382 11.363L327.904 11.5118ZM330.082 18.5L330.519 18.7432L340.538 0.743169L340.101 0.5L339.664 0.256831L329.645 18.2568L330.082 18.5ZM340.101 0.5L339.607 0.578143L341.35 11.5899L341.843 11.5118L342.337 11.4336L340.595 0.421857L340.101 0.5ZM341.843 11.5118V12.0118H360.5V11.5118V11.0118H341.843V11.5118Z"
              fill="#FFF380"
            />
          </svg>
        </div>

        <ul class="streaming-body__content-notes">
          <li
            class="streaming-body__content-notes-heading"
            v-html="mobileStreamingCopy.noticeHeadingHtml"
          />
          <li v-for="(line, idx) in archiveNoticeLines" :key="'arc-n-' + idx">
            ・{{ line }}
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
import { scrollToAnchorById } from "@/utils/mobile-anchor";
import streamingContent from "@/views/data/streaming-content.json";

/**
 * 移动端配信页：streaming-content.json（与 PC streaming 一致）
 */
export default {
  name: "MStreaming",
  data() {
    const page = streamingContent;
    return {
      mobileStreamingCopy: page.pcStreamingCopy,
      liveNoticeLines: page.liveNoticeLines,
      archiveNoticeLines: page.archiveNoticeLines,
    };
  },
  computed: {},
  methods: {},
  mounted() {
    this.$nextTick(() => {
      scrollToAnchorById("mobile-streaming", {
        behavior: "auto",
        block: "start",
      });
    });
  },
};
</script>

<style scoped lang="scss">
.mobile-streaming {
  color: #fff;
  font-family: 'Noto Sans JP', 'Noto Sans', sans-serif;
  font-style: normal;

  position: relative;
  background-image: url("@/assets/image/streaming/mobile_bg.webp");
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: scroll;
  z-index: 0;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    top: 230px;
    width: 100%;
    height: 100%;
    background-image: url(@/assets/image/streaming/mobile_bg_icon.webp);
    background-position: top left; /* 保持你要的左上角对齐 */
    background-size: 130% auto;
    background-repeat: no-repeat;
    animation: BackgroundFloat 6s ease-in-out infinite;
    z-index: 1;
  }

  /* 第一个 */
  .streaming-body:first-of-type {
    margin-bottom: 54px;
  }

  /* 最后一个 */
  .streaming-body:last-of-type {
    margin-bottom: 80px;
    padding-top: 0;

    .streaming-body__content-title--text {
      font-size: 18px;
    }
  }
}

.streaming-header {
  position: relative;
  width: 100%;
  box-sizing: border-box;
  z-index: 2;
  // background: rgba(0, 0, 0, 0.25);

  &__background {
    position: absolute;

    width: 100%;
    object-fit: contain;
    object-position: center;
  }

  &__dynamic {
    position: absolute;
    object-fit: contain;
    object-position: center;
    transform-origin: center center;
    will-change: transform;
    animation: mobile-header-img-dynamic 1.35s infinite;

    position: absolute;
    z-index: 9;

    &-cd {
      top: 00px;
      left: -90px;
    }
    &-lightning {
      top: 90px;
      right: 30px;
    }
  }

  &__title {
    padding: 90px 76px 76px;
  }

  &__deco {
    position: absolute;
    object-fit: contain;
    object-position: center;
    transform-origin: center center;
    will-change: transform;
    animation: ticket-deco-beat 1.35s infinite;

    &-circular {
      top: 39px;
      left: 204px;
      width: 300px;
    }

    &-star {
      top: 71px;
      right: 188px;
      width: 227px;
    }
  }
}

.streaming-body {
  position: relative;
  padding: 70px 40px 0;
  z-index: 2;

  &__content {
    // padding: 40px 36px 30px;
    border-radius: 8px;
    border: 1px solid #fff380;
    background: rgba(0, 0, 0, 0.25);
    -webkit-tap-highlight-color: transparent;
    transition: transform 0.22s ease, box-shadow 0.25s ease;

    &:active {
      transform: scale(0.992);
      box-shadow: 0 0 0 1px rgba(255, 243, 128, 0.35),
        0 12px 28px rgba(0, 0, 0, 0.35);
    }

    &-top {
      //   padding: 8px 0;
      padding: 40px 22px 30px;
    }

    &-title {
      padding: 0 0 8px;
      border-bottom: 1px solid #fff;

      &--text {
        color: #d9a2ff;
        font-size: 16px;
        font-weight: 600;
      }
      &--price {
        font-size: 14px;
        font-weight: 600;
      }
    }

    &-date {
      display: flex;
      align-items: center;
      gap: 8px;
      // padding: 10px 0 ;
      margin-top: 10px;

      &--label {
        width: 70px;
        padding: 4px 0;
        text-align: center;
        font-weight: 600;
        font-size: 12px;
        line-height: 100%;
        letter-spacing: 0%;
        background: #00000040;
      }
      &--value {
        // width: 100%;
        flex: 1;
        font-weight: 400;
        font-size: 14px;
        line-height: 100%;
        // letter-spacing: 0%;
      }
    }

    &-notes {
      margin: 0;
      padding: 30px 34px 40px;
      font-weight: 500;
      font-size: 14px;
      line-height: 200%;
      letter-spacing: 0%;
      text-align: left;
      list-style: none;

      li {
        list-style: none;
      }

      &-heading {
        margin-bottom: 0.35em;
      }
    }
  }
}

@media (prefers-reduced-motion: reduce) {
  .streaming-body__content {
    transition: none;
    &:active {
      transform: none;
      box-shadow: none;
    }
  }
}

/* 无限滚动横幅 */
.mobile-marquee {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 60px;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;

  background-image: url("@/assets/image/index/about_footer_bg.webp");

  &--description {
    position: absolute;
    left: 0;
    right: 0;
    bottom: -28px;
    z-index: 9;
  }

  &-inner {
    width: 100%;
    height: 24px;
    overflow: hidden;
    background-color: #191616;
    display: flex;
    align-items: center;
    border-top: 2px solid #d9a2ff;
    border-bottom: 2px solid #d9a2ff;
  }

  &-track {
    display: flex;
    width: max-content;
    flex-shrink: 0;
    align-items: center;
    animation: mobile-marquee 30s linear infinite;
    will-change: transform;

    @media (prefers-reduced-motion: reduce) {
      animation: none;
      will-change: auto;
    }
  }

  &-group {
    display: flex;
    flex-shrink: 0;
    align-items: center;
  }

  &-title {
    flex-shrink: 0;
    margin-right: 20px;
    width: 200px;
    height: 10px;
    object-fit: contain;
    object-position: center;
  }
}

/* 无限滚动动画 */
@keyframes mobile-marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

@keyframes mobile-header-img-dynamic {
  0%,
  42% {
    transform: scale(1);
    animation-timing-function: cubic-bezier(0.45, 0, 0.55, 1);
  }
  52% {
    transform: scale(0.9);
    animation-timing-function: cubic-bezier(0.55, 0.05, 0.6, 0.45);
  }
  58% {
    transform: scale(0.86);
    animation-timing-function: cubic-bezier(0.33, 1.15, 0.52, 1);
  }
  70% {
    transform: scale(1.08);
    animation-timing-function: cubic-bezier(0.22, 0.85, 0.38, 1);
  }
  80% {
    transform: scale(1);
    animation-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes BackgroundFloat {
  0% {
    background-position: top left;
    background-size: 130% auto;
    opacity: 0.85;
  }

  50% {
    /* 中心对称放大 → 向四周扩散 */
    background-position: top -60px left -60px;
    background-size: 150% auto;
    opacity: 1;
  }

  100% {
    /* 回到初始位置 */
    background-position: top left;
    background-size: 130% auto;
    opacity: 0.85;
  }
}
</style>
